export default "__VITE_ASSET__7e85005b__"